import { Injectable } from "@angular/core";
import { LoginService } from "./login.service";
import { CatalogService } from "./CatalogManagement/catalog.service";
import { Catalog } from "../Model/Catalog/Catalog";

@Injectable()
export class UserManagementService {


  constructor(public loginService: LoginService, public catalogService: CatalogService) {

  }

  canView(element: string): boolean{
    if (this.loginService.currentUser == undefined)
      return false;
    
    if(element == "jobs"  || element == "templates"){
      return (this.loginService.currentUser.currentClaim != "READONLY");
    }
    return (this.loginService.currentUser.currentClaim != "READONLY" && this.loginService.currentUser.currentClaim != "READONLY_WITH_EXPORT");
  }

  canExport(element: string): boolean {
    if (this.loginService.currentUser == undefined)
      return false;
    return (this.loginService.currentUser.currentClaim != "READONLY");
  }

  isReadOnlyWithExport(element: string = null): boolean {
    return (this.loginService.currentUser.currentClaim == "READONLY_WITH_EXPORT");
  }

  canEdit(element: string, catalog: Catalog = null): boolean {
    if (this.loginService.currentUser == undefined)
      return false;
    if (catalog?.pimGroup =="NP-Datahub")
      return false;
    return (this.loginService.currentUser.currentClaim != "READONLY" && this.loginService.currentUser.currentClaim != "READONLY_WITH_EXPORT");
  }

}
